import useHttpGet from '@/states/generics/useHttpGet'
import { getEmptyOrg } from '@/store/organization-model'
import { ref } from '@vue/composition-api'

export default function useOrg({ id, fetchImmediate = true }) {
  const org = ref(getEmptyOrg())

  const url = `/organizations/${id}`
  const { get, getInProgress } = useHttpGet({ url })

  const fetch = async () => {
    const response = await get()
    org.value = response.data
    return org.value
  }

  if (id && fetchImmediate) {
    fetch()
  }

  return {
    org,
    fetch,
    fetchInProgress: getInProgress,
  }
}
